// wa.me exige DDI. Número brasileiro sem DDI tem 10 (fixo) ou 11 (celular)
// dígitos; com DDI, 12 ou 13 começando por 55. Sem o 55, "1733648000" vira um
// número dos EUA (DDI 1).
export const toWhatsAppPhone = (phone?: string | null): string => {
  const digits = (phone || '').replace(/\D/g, '');
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) return digits;
  return '';
};
